<template>
    <div>
        <affiliate-workspace :sections="pricePointsTabs" :current="pricePointsTab" :error-sections="dropPixelPricePointsErrorTabs" label="Price points" @select="handlePricePointsTabChange">
        <div class="bg-white rounded p-2 mb-2">
            <div v-for="(pricePoint, index) in localDropPixel.price_points" :key="index">
                <div v-if="pricePointsTab === 'data_sharing_product_price_point_' + pricePoint.id"
                    class="flex flex-col w-full">
                    <div class="flex flex-col w-full bg-white mb-2">
                        <div class="flex flex-col w-full mr-2 mb-2">
                            <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_tracking_code')
                            }}</label>

                            <text-area v-model="pricePoint.tracking_code" class="w-full" :select-all="true"
                                value="pricePoint.tracking_code" :placeholder="$t('frontend_tracking_code')" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </affiliate-workspace>
    </div>
</template>
<script>
import AffiliateWorkspace from '../../components/AffiliateWorkspace.vue';
export default {
    components: { AffiliateWorkspace },

    props: {
        drop_pixel: {
            type: Object,
            required: true
        },
        pricePointsTabs: {
            type: Array,
            required: true
        },
        handlePricePointsTabChange: {
            type: Function,
            required: true
        },
        pricePointsTab: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            localDropPixel: this.drop_pixel
        }
    },
    watch: {
        localDropPixel: {
            handler: function (val, oldVal) {
                this.$emit('update-data', {
                    key: 'drop_pixel',
                    value: val
                });
            },
            deep: true
        }
    },
    computed: {
        dropPixelPricePointsErrorTabs() {
            return [];
        },
    }

}
</script>